import Navbar from "../componenets/Navbar";
import Sidebar from "../componenets/Sidebar";
import React, { useState, useEffect}  from 'react';
import TotalSentMessages from "../admin/components/TotalMessages";
import AllcustomersTable from "../admin/components/AllcustomersTable";
import { useNavigate } from "react-router-dom";

import swal from "sweetalert";
import axios from "axios";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useKawasans from "../componenets/useKawasans";


import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//test data for table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#596CFF",
        fontWeight: "bold",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  

const penjaja = [
    "PASAR HARIAN SELAYANG KUALA LUMPUR",
 "PASAR BERBANGUNAN UTC SENTUL",
 "PUSAT PENJAJA DANAU KOTA",
 "MEDAN SELERA SEKSYEN 4 WANGSA MAJU",
 "PASAR DAN PP WANGSA MAJU SEKYEN 2",
 "PUSAT PENJAJA JALAN DUTA",
 "PASAR BESAR TAMAN TUN DR ISMAIL",
 "PUSAT PENJAJA METRO PRIMA",
 "MEDAN SELERA PENJAJA TAMAN SETIAWANGSA",
 "PUSAT PENJAJA D'REJANG",
 "PUSAT PENJAJA JALAN USAHAWAN",
 "PUSAT PENJAJA LOT PT 432 (D'TASEK)",
 "PUSAT PENJAJA AIR PANAS",
 "PP SEMENTARA TAMAN KEJIRANAN AIR PANAS",
 "PASAR BERBANGUNAN KERAMAT MALL",
 "KIOSK LAMAN SEJAHTERA PPR SG BONUS",
 "PUSAT PENJAJA JALAN JEJAKA MALURI",
 "PASAR DAN PP JLN WIRAWATI KG PANDAN",
 "PUSAT PENJAJA TPCA JALAN RAJA MUDA",
 "PUSAT SEMBELIHAN AYAM SEMENTARA",
 "MEDAN SELERA DAMAI JALAN BATU BATA",
 "PUSAT PENJAJA BANDAR SERI PERMAISURI",
 "ANJUNG SELERA JALAN JUJUR",
 "PASAR SUNGAI BESI",
 "PUSAT PENJAJA PARK & RIDE SUNGAI BESI",
 "PUSAT KOMUNITI BANDAR TUN RAZAK",
 "PUSAT PENJAJA D'LAMAN RASA PEKAN SG BESI",
 "MEDAN SELERA TAMAN SUNGAI BESI",
 "PUSAT PENJAJA DESA TUN RAZAK",
 "PASAR TAMAN CHERAS",
 "PUSAT PENJAJA JALAN LOBAK",
 "PARK & RIDE TAMAN SEGAR",
 "PUSAT PENJAJA JALAN KUARI",
 "MEDAN SELERA D TASIK",
 "PASAR DAN PUSAT PENJAJA RAZAK MANSION",
 "PUSAT PENJAJA JALAN MEGA MENDUNG",
 "PASAR DAN PP KG BARU SALAK SELATAN",
 "PASAR JALAN KLANG LAMA",
 "PASAR DAN PUSAT PENJAJA TMN SERI SENTOSA",
 "PUSAT PENJAJA PUTRA RIA",
 "PUSAT PENJAJA BAZARIA PANTAI",
 "PUSAT PENJAJA SRI ANGKASA JAYA",
 "PP TAMAN BOTANI JALAN CENDERAWASIH",
 "KOMPLEKS MAKAN TANGLIN",
 "PP LITTLE INDIA II (KEDAI BUNGA)",
 "PP TEMPAT LETAK KERETA JLN BERHALA",
 "PUSAT PENJAJA PT80",
 "PUSAT PENJAJA SELERA MEDAN BUNUS",
 "KOMPLEKS TUN SAMBATHAN (PINES BAZAR)",
 "PP LRG ANTARA 495/497 JLN TAR CHOW KIT",
 "MEDAN SELERA D TEBING RIVER OF LIFE",
 "PP LITTLE INDIA II (KEDAI BURUNG)",
 "PP WANGSA MAJU SEK. 1 KAWASAN 2",
 "PUSAT PENJAJA SEKSYEN 10, WANGSA MAJU",
 "PP LITTLE INDIA III (PASARAYA SRI KOTA)",
 "MEDAN SELERA D'TASIK TITIWANGSA",
 "PASAR SEMENTARA CHERAS",
 "PUSAT PENJAJA JALAN CENDERASARI",
 "MEDAN SELERA SRI SEMARAK",
 "MEDAN SELERA JALAN ROTAN",
 "KOMPLEKS PASAR RAJA BOT",
 "BAZARIA WANGSA MAJU GENTING KLANG",
 "PUSAT PENJAJA JALAN THAVER KG PANDAN",
 "PUSAT PENJAJA JALAN CENDERASARI",
 "JLN RAJA BOT/JLN & LRG HAJJ HUSSEIN",
 "HENTIAN BAS JALAN TUN RAZAK",
 "PUSAT PENJAJA PT43, JALAN HAJI SALLEH",
 "MEDAN SELERA DAMAI JALAN BATU BATA",
 "JALAN BONUS 6 (GERAI BERKUNCI) / MEDAN B",
 "PUSAT PENJAJA AKED IBUKOTA",
 "PP  JALAN 101, TUANKU ABDUL RAHMAN",
 "PP  JALAN 107, TUANKU ABDUL RAHMAN",
 "MEDAN SELERA IKAN BAKAR BELLAMY",
 "PUSAT PENJAJA JALAN IKHLAS",
 "PUSAT PENJAJA TAMAN SALAK JAYA",
 "MEDAN SELERA TAMAN SUNGAI BESI",
 "PUSAT PENJAJA JALAN LOBAK",
 "PUSAT PENJAJA JALAN KUARI",
 "PP LRG ANTARA 495/497, JLN TAR CHOW KIT",
 "PUSAT PENJAJA PUTRA RIA",
 "PUSAT PENJAJA SRI ANGKASA JAYA",
 "PUSAT PENJAJA AKED TUANKU ABDUL RAHMAN",
 "PP TAMAN BOTANI, JALAN CENDERAWASIH",
 "PUSAT PENJAJA JALAN MELAYU/MASID INDIA",
 "PUSAT PENJAJA STATIK PETALING STREET",
 "PP PETALING STREET (JLN HANG LEKIR)",
 "DAPUR BERGERAK",
 "GTJ PARLIMEN TITIWANGSA",
 "GTJ PARLIMEN SETIAWANGSA",
 "GTJ PARLIMEN SEGAMBUT",
 "GTJ PARLIMEN BATU",
 "GTJ PARLIMEN KEPONG",
 "GTJ PARLIMEN WANGSA MAJU",
 "GTJ PARLIMEN BUKIT BINTANG",
 "GTJ PARLIMEN BANDAR TUN RAZAK",
 "GTJ PARLIMEN SEPUTEH",
 "GTJ PARLIMEN CHERAS",
 "GTJ PARLIMEN LEMBAH PANTAI",
 "TERMINATED LOCATION",
 "KIOSK PARLIMEN BUKIT BINTANG",
 "KIOSK PARLIMEN KEPONG",
 "KIOSK PARLIMEN TITIWANGSA",
 "KIOSK PARLIMEN BATU",
 "KIOSK PARLIMEN SEPUTEH",
 "KIOSK PARLIMEN CHERAS",
 "PUSAT KOMUNITI BANDAR TUN RAZAK",
 "PASAR BERBANGUNAN UTC SENTUL",
 "MEDAN SELERA SEKSYEN 4 WANGSA MAJU",
 "PUSAT PENJAJA JALAN DUTA",
 "PUSAT PENJAJA JALAN JEJAKA MALURI",
 "PUSAT PENJAJA METRO PRIMA",
 "PUSAT PENJAJA TPCA, JALAN RAJA MUDA",
 "PUSAT PENJAJA JALAN USAHAWAN",
 "PUSAT PENJAJA DANAU KOTA",
 "MEDAN SELERA PENJAJA TAMAN SETIAWANGSA",
 "PUSAT PENJAJA JALAN MEGA MENDUNG",
 "PUSAT PENJAJA SEKSYEN 10, WANGSA MAJU",
 "PUSAT PENJAJA LOT PT 432 (D'TASEK)",
 "PUSAT PENJAJA D'REJANG",
 "PUSAT PENJAJA PARK & RIDE SUNGAI BESI",
 "PUSAT PENJAJA PT80",
 "PUSAT PENJAJA BANDAR SERI PERMAISURI",
 "PUSAT PENJAJA MUTIARA BANGSAR",
 "KOMPLEKS TUN SAMBANTHAN (PINES) BAZAR",
 "PUSAT PENJAJA AIR PANAS",
 "PP LITTLE INDIA III (PASARAYA SRI KOTA)",
 "PUSAT PENJAJA BAZARIA PANTAI",
 "PP LITTLE INDIA II (KEDAI BUNGA)",
 "PASAR DAN PUSAT PENJAJA RAZAK MANSION",
 "MEDAN SELERA JALAN ROTAN",
 "PP TLK TAMAN SEGAR, CHERAS",
 "PUSAT PENJAJA SELERA MEDAN BUNUS",
 "PP TEMPAT LETAK KERETA JLN BERHALA",
 "KIOSK LAMAN SEJAHTERA PPR SG. BONUS",
 "PUSAT PENJAJA D'LAMAN RASA PEKAN SG BESI",
 "PP SEMENTARA TAMAN KEJIRANAN AIR PANAS",
 "TLK TMN TASIK METROPOLITAN KEPONG",
 "ANJUNG SELERA, JALAN JUJUR",
 "PP LUCKY GARDEN, LORONG ARA 3, BANGSAR",
 "MEDAN SELERA D'TASIK TITIWANGSA",
 "PP BERSEBELAHAN KUIL SRI NAGESWARI",
 "KIOSK TUGU PERINGATAN",
 "PLAZA SUNGAI MULIA GOMBAK",
 "KOMPLEKS MAKAN TANGLIN",
 "BAZARIA WANGSA MAJU (JLN GENTING KELANG)",
 "PASAR BORONG KUALA LUMPUR",
 "PASAR JALAN RAJA BOT/JALAN HAJI HUSSIEN",
 "PASAR BATU 2 1/2, JALAN IPOH",
 "PASAR AIR PANAS",
 "PASAR PUDU",
 "PASAR SENTUL",
 "PASAR DAN PP KG BARU SALAK SELATAN",
 "PASAR SUNGAI BESI",
 "PASAR BESAR TAMAN TUN DR ISMAIL",
 "PASAR TAMAN CHERAS",
 "PASAR DAN PP JLN WIRAWATI KG PANDAN",
 "PASAR DAN PUSAT PENJAJA TMN SERI SENTOSA",
 "PASAR WANGSA MAJU SEK. 1 (KAWASAN 1)",
 "PASAR PT 69 JALAN GENTING KLANG",
 "PASAR ALAM DAMAI",
 "PASAR KG. BATU 5 JALAN IPOH",
 "PASAR BERBANGUNAN KERAMAT MALL",
 "PASAR DAN PP WANGSA MAJU SEKYEN 2",
 "PASAR JALAN KLANG LAMA",
 "PASAR HARIAN SELAYANG KUALA LUMPUR",
 "PUSAT SEMBELIHAN AYAM SEMENTARA",
 "PASAR SEMENTARA CHERAS",
 "KOMPLEKS PASAR RAJA BOT",
 "JALAN SCOTT BRICKFIELDS",
 "USAHAWAN ANAK MUDA KOTA",
  ];
  const perumahan = [
     "PPR DESA TUN RAZAK",
 "PPR DESA PETALING",
 "PA SRI MELAKA 4D",
 "PA SRI MELAKA 4F",
 "PA SRI MELAKA 4G",
 "PPR LAKSAMANA",
 "PPR PERKASA",
 "PA SRI SABAH 3B",
 "PPR PUDU ULU",
 "PA SRI PULAU PINANG",
 "PA IKAN EMAS 1",
 "PA IKAN EMAS 2",
 "PA SRI JOHOR 4A",
 "PA SRI JOHOR 4B",
 "PA SRI JOHOR 4C",
 "PA SRI LABUAN",
 "PA SRI KOTA",
 "PPR SRI MALAYSIA",
 "KUARTERS PANTAI PERMAI",
 "PPR SALAK SELATAN",
 "PA KERINCHI 1A",
 "PPR SRI ANGGERIK",
 "PA SRI SELANGOR 1",
 "PA SRI SELANGOR 2",
 "PPR SRI CEMPAKA",
 "PPR KERINCHI LEMBAH PANTAI",
 "BANGLO KAYU KERINCHI",
 "PPR SRI PANTAI",
 "PPR KG MUHIBBAH",
 "PPR BUKIT JALIL",
 "PPR BUKIT JALIL BLOK L&M",
 "PA LOKE YEW 1",
 "PA LOKE YEW 2",
 "PA LOKE YEW 3",
 "PA LOKE YEW 4",
 "PA SRI SARAWAK",
 "PA HANG TUAH",
 "KOMPLEKS SAN PENG",
 "PPR SRI ALAM",
 "PPR PANTAI RIA",
 "PA SRI TRENGGANU",
 "PPR TAMAN WAHYU",
 "PPR PEKAN BATU",
 "PPR INTAN BAIDURI",
 "PA SRI PANGKOR 1",
 "SENTUL UTARA (KS)",
 "PPR KG BATU MUDA",
 "PPR BERINGIN",
 "PA SRI KELANTAN C",
 "KUARTERS KEPONG",
 "PA SRI NEGERI SEMBILAN",
 "PERUMAHAN BANDAR DBKL",
 "PA SETAPAK JAYA 1A",
 "PPR SG BONUS",
 "PA SRI KEDAH",
 "PPR KG BARU AIR PANAS",
 "PPR WANGSA SARI",
 "PPR GOMBAK SETIA",
 "PA SRI TIOMAN",
 "PA GOMBAK MODEN 3B",
 "PA SRI PERLIS 1",
 "PA SRI PERLIS 2",
 "PPR JELATEK",
 "PPR HILIRAN AMPANG",
 "PA LOKE YEW 1",
 "PA LOKE YEW 2",
 "PA LOKE YEW 3",
 "PA LOKE YEW 4",
 "PA HANG TUAH",
 "PA SRI SELANGOR 1",
 "PA SRI SELANGOR 2",
 "KOMPLEKS SAN PENG",
 "PA SRI SARAWAK",
 "PA KERINCHI 1A",
 "PPR SRI PANTAI",
 "PPR SRI ANGGERIK",
 "PPR PANTAI RIA",
 "PPR SRI CEMPAKA",
 "PPR SRI ALAM",
 "PPR KG MUHIBBAH",
 "PPR SALAK SELATAN",
 "PPR KG LIMAU",
 "PPR KERINCHI LEMBAH PANTAI",
 "PPR BUKIT JALIL",
 "PPR BUKIT JALIL BLOK L & M",
 "PA SRI KEDAH",
 "PA GOMBAK 2",
 "PA SRI TIOMAN I",
 "PA SETAPAK JAYA 1A",
 "PA PERLIS 1",
 "PA PERLIS 2",
 "PA DESA REJANG",
 "PA WANGSA MAJU R1",
 "PA WANGSA MAJU R10",
 "PA KELOMPOK KUANG & KENARI",
 "PA KOMPLEKS AS-SALAM",
 "PA KOMPLEKS UMMU SAADIAH",
 "PPR JELATEK",
 "PPR SRI SEMARAK",
 "PPR KG BARU AIR PANAS",
 "PPR SG BONUS",
 "PPR WANGSA SARI",
 "PPR GOMBAK SETIA",
 "PPR HILIRAN AMPANG",

  ]
  

const OutstandingBill = () => {
    const [customers, setCustomers] = useState([]);
    const [area, setArea] = useState([]);
    const [script, setScript] = useState();
    const kawasanOptions = useKawasans('air');

    const navigate = useNavigate();

    //select area outstanding
  async function findScriptOutstanding(req){
    console.log(req.target.value)
    if(req.target.value === 'penjaja_outstanding'){
      document.getElementById('penjaja_outstanding').style.display = "block"
      document.getElementById('perumahan_outstanding').style.display = "none"
      setScript(req.target.value)
    }
    else{
      document.getElementById('perumahan_outstanding').style.display = "block"
      document.getElementById('penjaja_outstanding').style.display = "none"
      setScript(req.target.value)
    }
  }

   //find customers by area
   async function findOutstandingCustomerLocation(req) {
    console.log(req.target.value)
    if(req.target.value){
        document.getElementById('search-table-area_outstanding').style.display = "block"
    }
    
    if(!req.target.value){
        document.getElementById('search-table-area_outstanding').style.display = "none"
    }
    
    const kod_kawasan = req.target.value
    return fetch('https://globizsystems.com/customers/get_outstanding_customer_by_location', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({kod_kawasan})
    })
    .then(response => response.json())
    .then(responseJson => {
      console.log(responseJson);
      setArea(responseJson)
    })
    
   }

   //find outstanding customer 
   async function findOutstandingCustomer(req) {
    console.log(req.target.value)
    if(req.target.value){
        document.getElementById('search-table-outstanding').style.display = "block"
    }
    
    if(!req.target.value){
        document.getElementById('search-table-outstanding').style.display = "none"
    }
    
    const account_no = req.target.value
    return fetch('https://globizsystems.com/customers/get_outstanding_customer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({account_no})
    })
    .then(response => response.json())
    .then(responseJson => {
      console.log(responseJson);
      setCustomers(responseJson)
    })
    
   }
  
   async function sendOutstandingMessage(id,bill_id, name,
    no_akaun_air, no_telefon_1, no_telefon_2, kawasan_sewaan, 
    current_amount, arrears_amount, total_due_amount, due_date, script, username
    ) {
  await axios
      .post("https://globizsystems.com/messages/send_outstanding_bill_single", {
        id:id,
        bill_id: bill_id,
        name: name,
        account_no: no_akaun_air,
        phone_no_1: no_telefon_1,
        phone_no_2: no_telefon_2,
        kawasan_sewaan: kawasan_sewaan,
        current_amount:current_amount,
        arrears_amount:arrears_amount,
        total_due_amount:total_due_amount,
        due_date: due_date,
        script: script,
        username: username
      })
      .then((response) => {
        console.log(response.data)
        if('success' in response.data){
          swal("Success", "Sent", "success", {
            buttons: false,
            timer: 2000,
          })
          setCustomers([])
          navigate("/messages");
        }else{
          swal("Failed", "Not Sent", "error", {
            buttons: false,
            timer: 2000,
          })
          setCustomers([])
          navigate("/messages");
        }
          
        
      });
    }

    //send outstanding messages
    async function sendOutstandingMessageArea(item) {
        await axios
          .post("https://globizsystems.com/messages/send_outstanding_bill", item)
          .then((response) => {
            console.log(response.data)
            if('success' in response.data){
              swal("Success", "Sent", "success", {
                buttons: false,
                timer: 2000,
              })
              document.getElementById(`outstanding-${item.id}`).style.display = 'none';
              navigate("/messages");
               
            }else{
              swal("Failed", "Not Sent", "error", {
                buttons: false,
                timer: 2000,
              })
              document.getElementById(item.id).style.display = 'none';
              navigate("/messages");
            }
              
            
          });
        }
      //end outstanding send messages



    return(
        <div className="container-fluid g-3 ">
                <h4 className="colorfix sizefix mx-2">Send Outstanding Billings</h4>
                    <div className="card px-2 pt-3 pb-3 mb-4 cardbg">
                        <div className="container-fluid" style={{backgroundColor:"white"}}>
                            <div className="container-fluid px-0 ">
                                <div className="col-12">
                                    <div className="container-fluid pb-4 pt-3 g-3">
                                        <div className="row ">

                                            <Box className="row" component="form" sx={{'& .MuiTextField-root': { m: 1, width: '40ch' }, }} noValidate autoComplete="off" >
                                                <div className="col-5">
                                                    <TextField
                                                    required
                                                    id="outlined-required"
                                                    label="Search Customer by Account Number"
                                                    defaultValue=""
                                                    onChange={findOutstandingCustomer}
                                                    />
                                                    
                                                </div>
                                                <div className="col-5 mt-2">
                                                  <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Choose Script</InputLabel>
                                                        <Select
                                                          labelId="demo-simple-select-label"
                                                          id="demo-simple-select"
                                                          label="Select Area"
                                                          onChange={findScriptOutstanding}
                                                        >
                                                          <MenuItem value={'penjaja_outstanding'}>Penjaja</MenuItem> 
                                                          <MenuItem value={'perumahan_outstanding'}>Perumahan</MenuItem>
                                                        </Select>
                                                  </FormControl>
                                                </div>
                                               
                                                <div className="col-8 mt-2 mx-2"  id="perumahan_outstanding" style={{display: "none"}}>
                                                <FormControl fullWidth>
                                                      <InputLabel id="demo-simple-select-label">Choose Location (Perumahan)</InputLabel>
                                                      <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Select Area"
                                                        onChange={findOutstandingCustomerLocation}
                                                      >
                                                              {kawasanOptions.perumahan.map((kawasan) => (
                                                                <MenuItem key={kawasan.kod_kawasan} value={kawasan.kod_kawasan}>
                                                                  {kawasan.nama_kawasan}
                                                                </MenuItem>
                                                              ))}
                                                      </Select>
                                                </FormControl>

                                                </div>

                                                <div className="col-8 mt-2 mx-2"  id="penjaja_outstanding" style={{display: "none"}}>
                                                  <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Choose Location (Penjaja)</InputLabel>
                                                        <Select
                                                          labelId="demo-simple-select-label"
                                                          id="demo-simple-select"
                                                          label="Penjaja"
                                                          onChange={findOutstandingCustomerLocation}
                                                        >
                                                              {kawasanOptions.penjaja.map((kawasan) => (
                                                                <MenuItem key={kawasan.kod_kawasan} value={kawasan.kod_kawasan}>
                                                                  {kawasan.nama_kawasan}
                                                                </MenuItem>
                                                              ))}
                                                                
                                                                
                                                        </Select>
                                                  </FormControl>
                                                </div>
                                                
                                                
                                            </Box>
                                            
                                                
                                            <div id="search-table-outstanding" style={{display: "none"}}>
                                                <legend><b>Outstanding Customer</b></legend>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                                        <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>ID</StyledTableCell>
                                                            <StyledTableCell>NAMA</StyledTableCell>
                                                            <StyledTableCell align="center">NO. AKAUN AIR</StyledTableCell>
                                                            <StyledTableCell align="center">NO. TELEFON (1)</StyledTableCell>
                                                            <StyledTableCell align="center">NO. TELEFON (2)</StyledTableCell>
                                                            <StyledTableCell align="center">ALAMAT UNIT</StyledTableCell>
                                                            <StyledTableCell>CURRENT DUE AMOUNT</StyledTableCell>
                                                            <StyledTableCell>ARREAS AMOUNT</StyledTableCell>
                                                            <StyledTableCell>TOTAL DUE AMOUNT</StyledTableCell>
                                                            <StyledTableCell>DUE DATE</StyledTableCell>
                                                            <StyledTableCell>ACTIONS</StyledTableCell>
                                                        </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        
                                                            <StyledTableRow key={customers?.customer_id}>
                                                            
                                                            
                                                            {customers?.current_amount ? (
                                                                    <>
                                                                      <StyledTableCell>{customers?.id}</StyledTableCell>
                                                                      <StyledTableCell>
                                                                          {customers?.nama}
                                                                      </StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.no_akaun_air}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.no_telefon_1}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.no_telefon_2}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.kawasan_sewaan}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.current_amount}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.arrears_amount}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.total_due_amount}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.due_date}</StyledTableCell>
                                                                      
                                                                      <StyledTableCell align="center">
                                                                  
                                                                      <button className="btn btn-primary" onClick={() => 
                                                                          sendOutstandingMessage(customers.id,customers.bill_id,customers.nama,customers.no_akaun_air,customers.no_telefon_1,
                                                                          customers.no_telefon_2, customers.kawasan_sewaan,customers.current_amount,
                                                                            customers.arrears_amount, customers.total_due_amount, customers.due_date, script, localStorage.getItem('username'))}>
                                                                          Send
                                                                      </button>
                                                                      </StyledTableCell>
                                                                    
                                                            
                                                                    </>
                                                                    
                                                                ):(
                                                                    <>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        
                                                                        <StyledTableCell size="center" align="center">
                                                                         <h4>no user found</h4>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                    </>
                                                                
                                                                )}
                                                            
                                                            </StyledTableRow>
                                                       
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                            
                                            <div id='search-table-area_outstanding' className="mt-3" style={{display: "none"}}>
                                           
                                            <legend><b>Total Outstanding Customer List by Area</b></legend>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                                        <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>ID</StyledTableCell>
                                                            <StyledTableCell>NAMA</StyledTableCell>
                                                            <StyledTableCell align="center">NO. AKAUN AIR</StyledTableCell>
                                                            <StyledTableCell align="center">NO. TELEFON (1)</StyledTableCell>
                                                            <StyledTableCell align="center">NO. TELEFON (2)</StyledTableCell>
                                                            <StyledTableCell align="center">KAWASAN SEWAAN</StyledTableCell>
                                                            <StyledTableCell>CURRENT DUE AMOUNT</StyledTableCell>
                                                            <StyledTableCell>ARREAS AMOUNT</StyledTableCell>
                                                            <StyledTableCell>TOTAL DUE AMOUNT</StyledTableCell>
                                                            <StyledTableCell>DUE DATE</StyledTableCell>
                                                            <StyledTableCell>ACTIONS</StyledTableCell>
                                                        </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        {area?.map(item => (
                                                          <>
                                                             {item.customer ?                                                          
                                                            <StyledTableRow key={item?.customer_id} id={`outstanding-${item.id}`}>
                                                            <StyledTableCell>{item?.id}</StyledTableCell>
                                                            <StyledTableCell>
                                                                {item?.customer?.nama}
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center">{item?.customer?.no_akaun_air}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.customer?.no_telefon_1}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.customer?.no_telefon_2}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.customer?.kawasan_sewaan}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.current_amount}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.arrears_amount}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.total_due_amount}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.due_date}</StyledTableCell>
                                                            <StyledTableCell align="center">

                                                                <button className="btn btn-primary" onClick={() => 
                                                                    sendOutstandingMessageArea(item)}>
                                                                      Send</button></StyledTableCell>
                                                            </StyledTableRow>
                                                            :
                                                            <>
                                                            </>
                                                              }
                                                          </>
                                                         
                                                        ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            
                                                
                                            </div>
                                            
                                            <br className="pt-4"/>
                                            <hr />
                                            {/* <AllcustomersTable /> */}
                                            
                                            {/* <TotalSentMessages /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    )
}

export default OutstandingBill;
